import {
  ADD_PRODUCT_TO_CART,
  SUB_PRODUCT_OF_CART,
  LOAD_CART_PAYTYPE_LIST_DATA,
  SET_DELETE_POPUP,
  UPDATE_DELETE_ITEM,
  REMOVE_PRODUCT_OF_CART
} from '@store/officialTopupNew/cart';
import {
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_SHOW_DETAIL_POPUP_DATA,
  CLOSE_DETAIL_POPUP,
  OPEN_GLOBAL_TIPS,
  UPDATE_SHOW_NO_AVAILABLE_PRODUCTS_POPUP,
  UPDATE_IS_AUTO_MATCH_PRODUCT,
  GET_VAT,
  MODIFY_TAX
} from '@store/officialTopupNew';
import { mapState, mapGetters } from 'vuex';
import {
  clickButton,
  locationType,
  showPopup,
  popupType
} from '@plugins/biPoint/_configWebstoreV35';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation
} from '@store/officialTopupNew/storager';
import globalConfig from '@utiles/officialStore/globalConfig';
import { b64EncodeUnicode } from '@utiles/officialStore';
import { ERROR_TYPE, errorReport } from '@utiles/errorReport';
import { hasGame440MutexConflict } from '@utiles/officialTopupNew/game440Product';

const GET_VAT_SUCCESS_RESULT = 1;

export default {
  props: {
    showDetailPopupBtn: {
      default: false
    }
  },
  data() {
    return {
      showLifeLimitPopup: false,
      lifeLimitProductContent: '',
      lifeLimitProductItem: null,
      updateCurrentTaxSeq: 0
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      cartList: state => state.cart.cartList,
      cartQuantityLimit: state => state.cart.cartQuantityLimit,
      deleteItem: state => state.cart.deleteItem,
      deleteIndex: state => state.cart.deleteIndex,
      paytype: state => state.paytype,
      curLocation: state => state.curLocation,
      curTax: state => state.curTax,
      gameId: state => state.gameId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      lang: state => state.lang,
      showNoAvailableProductsPopup: state => state.showNoAvailableProductsPopup,
      zipCode: state => state.zipCode
    }),
    ...mapGetters([
      'cartTotalQuantity',
      'cartTotalPrice',
      'cartDiscountTransMount',
      'cartProductType',
      'cartProductNum'
    ]),
    isShowTax() {
      return +this.curTax > 0 && this.curLocation === 'US';
    },
    realPrice() {
      const showPrice =
        this.cartTotalPrice + (this.isShowTax ? +this.curTax : 0);
      if (this.currency === 'VND') {
        return showPrice;
      }
      return showPrice.toFixed(2);
    }
  },
  methods: {
    async updateCurrentTax(info) {
      const seq = ++this.updateCurrentTaxSeq;
      try {
        const res = await this.$store.dispatch(GET_VAT, {
          zip_code: info.zipCode,
          amount: info.amount,
          currency: info.currency
        });
        if (seq !== this.updateCurrentTaxSeq) return;
        if (!res || +res.result !== GET_VAT_SUCCESS_RESULT) {
          this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.fail_and_later);
          errorReport(ERROR_TYPE.GET_VAT_FAIL, {
            zipCode: info.zipCode,
            amount: info.amount,
            currency: info.currency,
            result: res && res.result,
            msg: res && res.msg
          });
          return;
        }
        this.$store.commit(MODIFY_TAX, res.data?.TAX_AMOUNT);
      } catch (err) {
        if (seq !== this.updateCurrentTaxSeq) return;
        this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.fail_and_later);
        errorReport(ERROR_TYPE.GET_VAT_FAIL, {
          zipCode: info.zipCode,
          amount: info.amount,
          currency: info.currency,
          err: err && err.message ? err.message : String(err)
        });
      }
    },
    hideNoAvailableProductsPopup() {
      this.$store.commit(UPDATE_SHOW_NO_AVAILABLE_PRODUCTS_POPUP, false);
    },
    handleLifetimeLimitProduct() {
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.v3LifeLimitProductTip);
    },
    handleExclusiveProduct() {
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.v3ExclusiveProductTip);
    },
    handleCartMutexProduct() {
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.v3CartMutexProductTip);
    },
    handleSingleProductLimit(item) {
      this.$store.commit(
        OPEN_GLOBAL_TIPS,
        `${this.letter.limit_buy_product.replace('${n}', item.LIMIT)}`
      );
    },
    handleTotalProductLimit() {
      this.$store.commit(
        OPEN_GLOBAL_TIPS,
        `${this.letter.limit_order.replace('${n}', this.cartQuantityLimit)}`
      );
    },
    handleProductPriceError(item) {
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.fail_and_later);
      errorReport(ERROR_TYPE.POPUP_MATCH_CART_PRODUCT_LEVEL_FAIL, {
        productId: item?.PRODUCT_ID,
        cpProductId: item?.CP_PRODUCT_ID,
        amountLevel: item?.amountLevel
      });
    },
    addToCart(item, animateAddToCart) {
      this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, false);
      window.webstorev35DataLayer.push({
        eventName: 'select_product',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: 1,
          product_currency: item.CURRENCY || '',
          product_money: item.GAME_AMOUNT || ''
        }
      });
      const errorHandle = {
        singleProductLimit: 'handleSingleProductLimit',
        totalProductLimit: 'handleTotalProductLimit',
        productPriceError: 'handleProductPriceError',
        exclusiveProduct: 'handleExclusiveProduct',
        lifetimeLimitProduct: 'handleLifetimeLimitProduct',
        cartMutexProduct: 'handleCartMutexProduct'
      };

      const cartItem = this.cartList.find(cartItem => cartItem.PRODUCT_ID === item.PRODUCT_ID && cartItem.CP_PRODUCT_ID === item.CP_PRODUCT_ID);
      const quantity = cartItem ? cartItem.quantity : 0;

      if (+quantity >= +item.LIMIT) {
        this[errorHandle.singleProductLimit](item);
        return;
      }
      if (this.cartTotalQuantity + 1 > this.cartQuantityLimit) {
        this[errorHandle.totalProductLimit]();
        return;
      }
      if (
        !item.amountLevel ||
        !item.amountLevel?.TRANS_AMOUNT ||
        !item.amountLevel?.SHOW_CURRENCY
      ) {
        this[errorHandle.productPriceError](item);
        return;
      }

      if (+this.gameId === 386) {
        const exclusiveProductList = [
          'com.gravitygamevision.roworld.aos.bs2',
          'com.gravitygamevision.roworld.aos.bs3'
        ];
        // 当前商品是互斥商品，且购物车中已有另一个互斥商品（不是当前商品），则提示互斥
        if (item?.PRODUCT_ID && exclusiveProductList.includes(item.PRODUCT_ID) &&
          this.cartList.some(cartItem =>
            exclusiveProductList.includes(cartItem.PRODUCT_ID) &&
            cartItem.PRODUCT_ID !== item.PRODUCT_ID
          )
        ) {
          this[errorHandle.exclusiveProduct]();
          return;
        }
        const LIFE_LIMIT_PRODUCT_ID = 'com.gravitygamevision.roworld.aos.dm11';
        const LIFE_LIMIT_CP_PRODUCT_ID = '100011';
        // 终身限购商品提示
        if (item?.PRODUCT_ID === LIFE_LIMIT_PRODUCT_ID && item?.CP_PRODUCT_ID === LIFE_LIMIT_CP_PRODUCT_ID && this.cartList.some(cartItem => cartItem.PRODUCT_ID === LIFE_LIMIT_PRODUCT_ID && cartItem.CP_PRODUCT_ID === LIFE_LIMIT_CP_PRODUCT_ID)) {
          this[errorHandle.lifetimeLimitProduct]();
          return;
        }

        // 终身限购商品加入购物车提示
        if (item?.PRODUCT_ID === LIFE_LIMIT_PRODUCT_ID && item?.CP_PRODUCT_ID === LIFE_LIMIT_CP_PRODUCT_ID) {
          this.lifeLimitProductContent = this.letter.v3LifeLimitAddToCartTip.replaceAll('productName', item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '');
          this.lifeLimitProductItem = item;
          this.showLifeLimitPopup = true;
          return;
        }
      }

      // 针对440游戏，加购时做互斥商品校验
      if (+this.gameId === 440 && hasGame440MutexConflict(item, this.cartList)) {
        this[errorHandle.cartMutexProduct]();
        return;
      }

      this.doAddToCart(item);
      if (animateAddToCart && typeof animateAddToCart === 'function') {
        animateAddToCart();
      }
    },
    doAddToCart(item) {
      this.$store.commit(ADD_PRODUCT_TO_CART, item);
      this.$store.commit(CLOSE_DETAIL_POPUP);
    },
    handleProductDetail(item) {
      this.$store.commit(UPDATE_SHOW_DETAIL_POPUP_DATA, {
        item,
        showBtn: this.showDetailPopupBtn,
        show: true
      });
    },
    doSubProduct(item, index) {
      if (+item.quantity === 1) {
        this.$store.commit(SET_DELETE_POPUP, true);
        this.$store.commit(UPDATE_DELETE_ITEM, item);
        showPopup(popupType.removeCartProductPopup);
        return;
      }
      this.subProduct(item);
    },
    cancelSubProduct() {
      this.$store.commit(SET_DELETE_POPUP, false);
    },
    subProduct(item) {
      this.$store.commit(SUB_PRODUCT_OF_CART, item);
    },
    doRemoveProduct(item, index) {
      this.$store.commit(SET_DELETE_POPUP, true);
      this.$store.commit(UPDATE_DELETE_ITEM, item);
      showPopup(popupType.removeCartProductPopup);
    },
    removeProduct(item) {
      // 删除数组中这个index的元素
      this.$store.commit(REMOVE_PRODUCT_OF_CART, item);
      window.webstorev35DataLayer.push({
        eventName: 'remove_cart',
        eventType: 'add_to_cart',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: item.CP_PRODUCT_ID || '',
          product_id: item.PRODUCT_ID || '',
          product_num: 1,
          product_currency: item.CURRENCY || '',
          product_money: item.GAME_AMOUNT || ''
        }
      });
    },
    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {}
        };
      });
    },
    sendCheckCartData() {
      window.webstorev35DataLayer.push({
        eventName: 'check_cart',
        eventType: 'add_to_cart',
        eventReason: 'click_select',
        eventValue: {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_num: this.cartList.length,
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_currency: this.currency,
          product_money: this.cartTotalPrice
        }
      });
    },
    loadCartPayTypeListData() {
      if (!this.cartList.length) return;

      if (this.cartProductNum === 1) {
        // 购物车只有1个商品走单个商品支付渠道获取
        const item = this.cartList[0];
        storeProductParam({
          gameId: this.gameId,
          serverId: this.$store.state.pcServerId,
          roleId: this.$store.state.roleId,
          roleName: this.roleName,
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.uid,
          productId: item?.PRODUCT_ID || '',
          cpProductId: item?.CP_PRODUCT_ID || '',
          devicePlate: globalConfig.getHrefParam('devicePlate'),
          remark: item?.REMARK || '',
          location: getCurLocation() || '',
          appLanguage: this.lang,
          language: this.lang,
          productType: this.cartProductType
        });
        storeCpProductId(item?.CP_PRODUCT_ID || '');
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
      } else {
        // 多个商品走购物车支付渠道获取
        this.sendCheckCartData();
        storeProductParam({
          gameId: this.gameId,
          serverId: this.$store.state.pcServerId,
          roleId: this.$store.state.roleId,
          roleName: this.roleName,
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.uid,
          devicePlate: globalConfig.getHrefParam('devicePlate'),
          location: getCurLocation() || '',
          appLanguage: this.lang,
          language: this.lang,
          productType: this.cartProductType
        });
        this.$store.commit(UPDATE_LOADING, true);
        this.$store.dispatch(LOAD_CART_PAYTYPE_LIST_DATA);
        this.$emit('closeSelecter');
      }
    }
  }
};
